var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import DataBox from "~/components/common/data-box.vue";
import FollowModify from "~/components/collection-manage/co-urging/follow-modify.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { Prop } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { namespace } from "vuex-class";
import { CaseFollowRecordService } from "~/services/business-service/case-follow-record.service";
import { UploadFileService } from "~/services/common-service/upload-file.service";
var collectionManageModule = namespace("collection-manage");
var FollowDetailsQuery = /** @class */ (function (_super) {
    __extends(FollowDetailsQuery, _super);
    function FollowDetailsQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.followId = "";
        _this.loading = {
            state: false
        };
        _this.currentCase = {};
        _this.dataSet = [];
        _this.queryParamsModel = {
            certificateNo: "",
            collectionWay: 0,
            type: ""
        };
        _this.dialog = {
            followModify: false,
            certificate: false,
            record: false,
            video: false
        };
        return _this;
    }
    FollowDetailsQuery.prototype.created = function () { };
    FollowDetailsQuery.prototype.mounted = function () { };
    FollowDetailsQuery.prototype.refreshData = function () {
        var _this = this;
        this.queryParamsModel.certificateNo = this.certificateNo;
        this.queryParamsModel.type = "ADDR";
        this.loading.state = true;
        this.caseFollowRecordService.getAllCaseFollowRecord(this.queryParamsModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        }, function (err) { return _this.$message.error(err.msg); });
    };
    FollowDetailsQuery.prototype.onEdit = function (data) {
        this.followId = data;
        this.dialog.followModify = true;
    };
    /**
     *
     */
    FollowDetailsQuery.prototype.certificateDetails = function (follow) {
        this.currentCase = follow;
        this.dialog.certificate = true;
    };
    __decorate([
        Dependencies(PageService)
    ], FollowDetailsQuery.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], FollowDetailsQuery.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseFollowRecordService)
    ], FollowDetailsQuery.prototype, "caseFollowRecordService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], FollowDetailsQuery.prototype, "uploadFileService", void 0);
    __decorate([
        Prop()
    ], FollowDetailsQuery.prototype, "certificateNo", void 0);
    __decorate([
        Prop()
    ], FollowDetailsQuery.prototype, "assistOutType", void 0);
    FollowDetailsQuery = __decorate([
        Component({
            components: {
                DataBox: DataBox,
                FollowModify: FollowModify
            }
        })
    ], FollowDetailsQuery);
    return FollowDetailsQuery;
}(Vue));
export default FollowDetailsQuery;
